"use client";

import { useMetadata } from "@/hooks/useMetadata";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { Mascot } from "@/components/Mascot";

export default function NotFoundPage() {
  useMetadata({ key: "not-found" });

  return (
    <div className="min-h-screen bg-background text-foreground overflow-hidden relative flex flex-col">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(90deg,transparent,transparent_59px,rgba(255,214,0,0.04) 59px,rgba(255,214,0,0.04) 60px),repeating-linear-gradient(0deg,transparent,transparent_59px,rgba(255,214,0,0.04) 59px,rgba(255,214,0,0.04) 60px)",
        }}
      />
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "linear-gradient(to bottom,transparent 50%,rgba(255,214,0,0.012) 50%)",
          backgroundSize: "100% 4px",
        }}
      />

      <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-6 py-20">
        <div className="w-full max-w-md space-y-8 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-y/30 bg-y/5">
            <span className="w-1.5 h-1.5 rounded-full bg-y animate-pulse" />
            <span className="text-xs font-black uppercase tracking-[0.3em] text-y">
              404
            </span>
          </div>

          <div className="flex justify-center">
            <Mascot state="strict" size="large" className="animate-fade-in" />
          </div>

          <div className="space-y-2">
            <h1 className="font-display text-4xl md:text-5xl uppercase tracking-tight leading-none">
              You Are Lost.
            </h1>
            <p className="text-sm text-muted-foreground max-w-sm mx-auto leading-relaxed">
              This page does not exist. Perhaps you misread the syllabus.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              onClick={() =>
                history.length > 1
                  ? history.back()
                  : location.replace("/dashboard")
              }
              className="font-black uppercase tracking-widest text-xs"
            >
              Go Back
            </Button>
            <Link
              href="/dashboard"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 border border-border font-black text-xs uppercase tracking-[0.2em] rounded-xl hover:border-y active:scale-[0.98] transition-all"
            >
              Return Home
            </Link>
          </div>
        </div>
      </div>

      <div className="relative z-10 border-t border-border px-6 py-4">
        <p className="text-center text-xs font-black uppercase tracking-[0.3em] text-muted-foreground">
          UniUI — Academic Intelligence Platform
        </p>
      </div>
    </div>
  );
}
